import { createAsyncThunk } from "@reduxjs/toolkit"
import apiRequest from "../../lib/http"
import { normalizeError } from "../../utils/errorHelpers"

export const getQcCallResults = createAsyncThunk('qcCall/getQcCallResults', async (userId, { rejectWithValue }) => {
  try {
    const response = await apiRequest.get(`/qc-call-results/${userId}`)
    return response.data
  } catch (error) {
    return rejectWithValue(normalizeError(error))
  }
})

export const getQcRecordingUrl = createAsyncThunk('qcCall/getQcRecordingUrl', async (id, { rejectWithValue }) => {
  try {
    const response = await apiRequest.get(`/qc-call-results/${id}/recording-url`)
    return response.data
  } catch (error) {
    return rejectWithValue(normalizeError(error))
  }
})

export const reviewQcCallResult = createAsyncThunk('qcCall/reviewQcCallResult', async ({ id, decision, note }, { rejectWithValue }) => {
  try {
    const response = await apiRequest.patch(`/qc-call-results/${id}/review`, { decision, note })
    return response.data
  } catch (error) {
    return rejectWithValue(normalizeError(error))
  }
})
